export enum EvidenceTypesEnum {
  upload = 'upload',
  noEvidence = 'no_evidence',
  online = 'online',
}